// extracted by mini-css-extract-plugin
export default {"root":"ToolTip_root__3xlMe","tip":"ToolTip_tip__19wIe","tooltip":"ToolTip_tooltip__3xu2Z","open":"ToolTip_open__2XQgG"};